import { randomInt } from "../../../config/util-functions"

export function getNoOfLines({ lines, minLines, maxLines }) {
    let noOfLines = lines
    if (minLines) {
        if (maxLines && maxLines <= minLines) {
            throw new Error("maxLines must be greater than minLines.")
        } else if (!maxLines) {
            maxLines = minLines
        }
        // randomInt function is exclusive on max, so add one
        noOfLines = randomInt(minLines, maxLines + 1)
    }
    return noOfLines
}
